var map = {
	"./AssignmentFlag.svg": [
		45007,
		[
			5007
		]
	],
	"./Basemap.svg": [
		28321,
		[
			8321
		]
	],
	"./ChevronDown.svg": [
		35931,
		[
			5931
		]
	],
	"./ChevronLeft.svg": [
		67292,
		[
			7292
		]
	],
	"./ChevronRight.svg": [
		19747,
		[
			9747
		]
	],
	"./ChevronRightBrandGreen.svg": [
		77695,
		[
			7695
		]
	],
	"./ChevronRightSmall.svg": [
		52608,
		[
			2608
		]
	],
	"./Close.svg": [
		53897,
		[
			6278
		]
	],
	"./CloseLg.svg": [
		86253,
		[
			6253
		]
	],
	"./CloseLgWithPadding.svg": [
		91668,
		[
			1668
		]
	],
	"./Deforestation.svg": [
		60931,
		[
			931
		]
	],
	"./Delete.svg": [
		34739,
		[
			4739
		]
	],
	"./DrawPolygon.svg": [
		66762,
		[
			6762
		]
	],
	"./Edit.svg": [
		13166,
		[
			3166
		]
	],
	"./EditPolygon.svg": [
		36692,
		[
			6692
		]
	],
	"./EmptyAreas.svg": [
		54101,
		[
			4101
		]
	],
	"./EmptyReports.svg": [
		74694,
		[
			4694
		]
	],
	"./EmptyTeams.svg": [
		5657,
		[
			5657
		]
	],
	"./Error.svg": [
		10776,
		[
			776
		]
	],
	"./ExternalLink.svg": [
		56443,
		[
			6443
		]
	],
	"./FactCheck.svg": [
		49436,
		[
			9436
		]
	],
	"./GreenPlus.svg": [
		62707,
		[
			2707
		]
	],
	"./Help.svg": [
		25611,
		[
			5611
		]
	],
	"./Info.svg": [
		22410,
		[
			2410
		]
	],
	"./InfoBubble.svg": [
		58120,
		[
			8120
		]
	],
	"./LoginIcon.svg": [
		7046,
		[
			7046
		]
	],
	"./MapKey.svg": [
		80005,
		[
			5
		]
	],
	"./MapSlider.svg": [
		41767,
		[
			1767
		]
	],
	"./Minus.svg": [
		60934,
		[
			934
		]
	],
	"./People.svg": [
		61975,
		[
			1975
		]
	],
	"./Plus.svg": [
		44238,
		[
			4238
		]
	],
	"./PlusForButton.svg": [
		32303,
		[
			2303
		]
	],
	"./PlusWhite.svg": [
		74477,
		[
			4477
		]
	],
	"./Profile.svg": [
		34897,
		[
			4897
		]
	],
	"./RadioOff.svg": [
		45286,
		[
			5286
		]
	],
	"./RadioOn.svg": [
		19632,
		[
			9632
		]
	],
	"./Reports.svg": [
		88695,
		[
			8695
		]
	],
	"./Routes.svg": [
		50332,
		[
			332
		]
	],
	"./Search.svg": [
		61082,
		[
			1082
		]
	],
	"./area.svg": [
		83209,
		[
			3209
		]
	],
	"./assignmentIcons/areas.svg": [
		82006,
		[
			2006
		]
	],
	"./assignmentIcons/assignment-type.svg": [
		88656,
		[
			8656
		]
	],
	"./assignmentIcons/creation.svg": [
		42015,
		[
			2015
		]
	],
	"./assignmentIcons/monitor.svg": [
		66766,
		[
			6766
		]
	],
	"./assignmentIcons/notes.svg": [
		38555,
		[
			8555
		]
	],
	"./assignmentIcons/status.svg": [
		36994,
		[
			6994
		]
	],
	"./assignmentIcons/templates.svg": [
		7165,
		[
			7165
		]
	],
	"./check-doc.svg": [
		53835,
		[
			3835
		]
	],
	"./check-green.svg": [
		53800,
		[
			3800
		]
	],
	"./check.svg": [
		53658,
		[
			3658
		]
	],
	"./checkbox-off.svg": [
		58029,
		[
			8029
		]
	],
	"./checkbox-on.svg": [
		11769,
		[
			1769
		]
	],
	"./chevron-left.svg": [
		58063,
		[
			8063
		]
	],
	"./delete-round.svg": [
		13660,
		[
			3660
		]
	],
	"./download.svg": [
		59474,
		[
			9474
		]
	],
	"./facebook-logo.svg": [
		29790,
		[
			9790
		]
	],
	"./flag-white.svg": [
		97488,
		[
			7488
		]
	],
	"./flag.svg": [
		98944,
		[
			8944
		]
	],
	"./footprint.svg": [
		84243,
		[
			4243
		]
	],
	"./google-logo.svg": [
		31629,
		[
			1629
		]
	],
	"./kebab-hover.svg": [
		19312,
		[
			9312
		]
	],
	"./kebab.svg": [
		28405,
		[
			8405
		]
	],
	"./link.svg": [
		21602,
		[
			1602
		]
	],
	"./logo.svg": [
		4875,
		[
			4875
		]
	],
	"./mapCardIcons/Areas.svg": [
		66103,
		[
			6103
		]
	],
	"./mapCardIcons/Reports.svg": [
		36768,
		[
			6768
		]
	],
	"./mapKeyIcons/Alerts.svg": [
		8213,
		[
			8213
		]
	],
	"./mapKeyIcons/AssignmentsAssigned.svg": [
		44498,
		[
			4498
		]
	],
	"./mapKeyIcons/AssignmentsCreated.svg": [
		35206,
		[
			5206
		]
	],
	"./mapKeyIcons/ImportedReports.svg": [
		91021,
		[
			1021
		]
	],
	"./mapKeyIcons/MyReports.svg": [
		25187,
		[
			5187
		]
	],
	"./mapKeyIcons/VIIRSAlerts.svg": [
		48200,
		[
			8200
		]
	],
	"./mapKeyIcons/VIIRSReports.svg": [
		14154,
		[
			4154
		]
	],
	"./oval.svg": [
		12446,
		[
			2446
		]
	],
	"./target.svg": [
		87981,
		[
			7981
		]
	],
	"./translate.svg": [
		95964,
		[
			5964
		]
	],
	"./white-foot.svg": [
		27230,
		[
			7230
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77658;
module.exports = webpackAsyncContext;